import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import CheckCSName from "../CheckCSName";
import ResultBody from "../../../components/table/ResultBody";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";

export default function SV1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV01.error_id: {
            return (
                <ResultText>
                    The culvert invert elevations are not consistent with the survey data at the following {row?.data?.length} culverts.
                    <ResultTable maxWidth={HecRasHelper.getWidth(60)}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>Culvert</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>US</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>DS</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {

                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>
                                                Culvert {r?.culvert_num} RS <CheckCSName csName={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.survey_us?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.survey_us?.toFixed(2), r?.culv_us?.toFixed(2))}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.survey_ds?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.survey_ds?.toFixed(2), r?.culv_ds?.toFixed(2))}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </ResultText>
            )
        }
    }
}